export const translations = {
    'nl_NL': {
        label: 'Zoek op tarieven, verhuisservice, etc',
        button: 'Zoeken'
    },
    'nl_BE': {
        label: 'Zoek op deze website',
        button: 'Zoeken'
    },
    'fr_BE': {
        label: 'Rechercher sur le site Internet',
        button: 'Recherche'
    },
    'en_GB': {
        label: 'Search this website',
        button: 'Search'
    }
}
